import { render, staticRenderFns } from "./_query.vue?vue&type=template&id=a5333792&scoped=true&"
import script from "./_query.vue?vue&type=script&lang=ts&"
export * from "./_query.vue?vue&type=script&lang=ts&"
import style0 from "./_query.vue?vue&type=style&index=0&id=a5333792&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5333792",
  null
  
)

export default component.exports